import { defineMessages } from 'react-intl';

/**
 * The lines of the activity timeline (design t2, t3). The client composes each line from the kind
 * and the fields of the event: the API sends no text.
 */
export const activityMessages = defineMessages({
  sent: { id: 'app.outreach.live.activity.sent', defaultMessage: '{who} got your pitch' },
  followUp: { id: 'app.outreach.live.activity.followUp', defaultMessage: '{who} got your follow-up' },
  opened: { id: 'app.outreach.live.activity.opened', defaultMessage: '{who} opened your pitch page' },
  listened: { id: 'app.outreach.live.activity.listened', defaultMessage: '{who} listened to {song} for {duration}' },
  clicked: { id: 'app.outreach.live.activity.clicked', defaultMessage: '{who} opened {song} on {service}' },
  replied: { id: 'app.outreach.live.activity.replied', defaultMessage: '{who} replied about {song}' },
  placed: { id: 'app.outreach.live.activity.placed', defaultMessage: '{who} added {song}' },
  placedAt: { id: 'app.outreach.live.activity.placedAt', defaultMessage: '{who} added {song} at position {position}' },
  found: {
    id: 'app.outreach.live.activity.found',
    defaultMessage: 'Plug found {count, plural, one {# new curator} other {# new curators}} who fit {song}',
  },
  ready: {
    id: 'app.outreach.live.activity.ready',
    defaultMessage: 'Plug wrote {count, plural, one {# pitch} other {# pitches}} for {song}',
  },
  yourSong: { id: 'app.outreach.live.activity.yourSong', defaultMessage: 'your song' },
  someone: { id: 'app.outreach.live.activity.someone', defaultMessage: 'A curator' },
  followers: { id: 'app.outreach.live.activity.followers', defaultMessage: '{count} followers' },
  foundMeta: { id: 'app.outreach.live.activity.foundMeta', defaultMessage: 'Added to the queue' },
  readyMeta: { id: 'app.outreach.live.activity.readyMeta', defaultMessage: 'You read them before they go' },
  answer: { id: 'app.outreach.live.activity.answer', defaultMessage: 'Answer' },
  seeThem: { id: 'app.outreach.live.activity.seeThem', defaultMessage: 'See them' },
  readThem: { id: 'app.outreach.live.activity.readThem', defaultMessage: 'Read them' },
  minutesSeconds: { id: 'app.outreach.live.duration.minSec', defaultMessage: '{min} min {sec} s' },
  minutes: { id: 'app.outreach.live.duration.min', defaultMessage: '{min} min' },
  seconds: { id: 'app.outreach.live.duration.sec', defaultMessage: '{sec} s' },
});
